module.exports = __webpack_public_path__ + "static/media/collect-marketing-data.8e592595.png";